import React from "react";
import { banner } from "../../components/imagepath";
import { hooks } from "../../studentportal-sdk";
import { Controller, useForm } from "react-hook-form";

const ForgotPassword = (props) => {

  const {
    /**
     * authentication service
     */
    authService: {
      action: { userEmailVerification,},
    },
   
  } = props;

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    // resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {

    userEmailVerification(data);
  };

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-left">
              <img className="img-fluid" src={banner} alt="Logo" />
              </div>
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Request Password Request</h1>
                  <p className="account-subtitle">Let Us Help You</p>
                  {/* Form */}
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label>
                        Enter your registered email address{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="email"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            className={`form-control  ${
                              errors?.email ? "error-input" : ""
                            }`}
                            type="text"
                            value={value}
                            onChange={onChange}
                            autoComplete="false"
                            placeholder="example@gmail.com"
                          />
                        )}
                        // defaultValue=""
                      />
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                      >
                        Send Request
                      </button>
                    </div>
                    {/* <div className="form-group mb-0">
                      <button
                        className="btn btn-primary primary-reset btn-block"
                        type="submit"
                        onClick="./admindashboard"
                      >
                        Login
                      </button>
                    </div> */}
                  </form>
                  {/* /Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
  /* eslint-disable */
export default (props) => <ForgotPassword  {...hooks.authentication(props)}/>;
